import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/cat.png'


const _withScopeId = n => (_pushScopeId("data-v-62c5d25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper_books-page" }
const _hoisted_2 = { class: "books-page" }
const _hoisted_3 = { class: "navbar" }
const _hoisted_4 = { class: "navbar__back-button__img" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "navbar__back-button__text" }, "Назад", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "books-page__title" }, "В мире книг", -1))
const _hoisted_7 = { class: "books-page__content__wrapper" }
const _hoisted_8 = { class: "books-page__books" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "books-page__fields__title" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"opacity":"1","cursor":"default"} }, "Книги")
], -1))
const _hoisted_10 = { class: "books-page__fields__list" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { style: {"position":"absolute","top":"50%","bottom":"50%","left":"20px"} }
const _hoisted_13 = { class: "books-page__fields__list__item__check" }
const _hoisted_14 = { class: "books-page__fields__list__item__warn" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "books-page__fields" }
const _hoisted_17 = { class: "books-page__fields__list" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "books-page__fields__title" }, "Жанры фольклора", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "books-page__fields__title" }, "Не являются жанрами фольклора", -1))
const _hoisted_20 = { class: "books-page__footer-wrapper" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "cat"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_left_outlined = _resolveComponent("arrow-left-outlined")!
  const _component_holder_outlined = _resolveComponent("holder-outlined")!
  const _component_check_square_outlined = _resolveComponent("check-square-outlined")!
  const _component_warning_outlined = _resolveComponent("warning-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "navbar__back-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('./')))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_arrow_left_outlined)
          ]),
          _hoisted_5
        ])
      ]),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.books, (book) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "books-page__fields__list__item nested",
                key: book,
                onDragenter: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dropItem($event)))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`books-page__book-item ${book.type}`),
                  id: `book-${book.id}`,
                  draggable: "true",
                  onDragstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragItem($event))),
                  onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                  onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_holder_outlined)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_check_square_outlined)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_warning_outlined)
                  ]),
                  _createElementVNode("img", {
                    src: require(`../assets/${book.name}.png`),
                    alt: `${book}`,
                    draggable: "false"
                  }, null, 8, _hoisted_15)
                ], 42, _hoisted_11)
              ], 32))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _hoisted_18,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
                return _createElementVNode("div", {
                  class: "books-page__fields__list__item falk-list",
                  key: index,
                  onDragenter: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
                  onDragover: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dropItem($event)))
                }, null, 32)
              }), 64))
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
                return _createElementVNode("div", {
                  class: "books-page__fields__list__item idk-list",
                  key: index,
                  onDragover: [
                    _cache[11] || (_cache[11] = ($event: any) => (_ctx.allowDrop($event))),
                    _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
                  ],
                  onDragenter: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dropItem($event)))
                }, null, 32)
              }), 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.checkBooks()))
        }, "Проверить ")
      ])
    ]),
    _hoisted_21
  ]))
}